import React from 'react';

// Hand-drawn avatar SVGs live in /public/avatars/. The wire format is
// 'm0'..'m7' to keep them distinguishable from legacy emoji avatars and
// to avoid churning the server's AVATARS list when the artwork changes.
const MASCOT_NAMES = [
  'cat',
  'dino',
  'dog',
  'ducky',
  'giraffe',
  'monkey',
  'pig',
  'turtle',
];

export const MASCOT_COUNT = MASCOT_NAMES.length;

export function isMascotId(value) {
  return typeof value === 'string' && /^m[0-9]+$/.test(value);
}

export function mascotIndex(value) {
  if (!isMascotId(value)) return null;
  const n = parseInt(value.slice(1), 10);
  return Number.isFinite(n) ? ((n % MASCOT_NAMES.length) + MASCOT_NAMES.length) % MASCOT_NAMES.length : null;
}

export function mascotIdAt(index) {
  return `m${((index % MASCOT_NAMES.length) + MASCOT_NAMES.length) % MASCOT_NAMES.length}`;
}

export const ALL_MASCOT_IDS = MASCOT_NAMES.map((_, i) => `m${i}`);

export function mascotName(value) {
  const idx = typeof value === 'number'
    ? ((value % MASCOT_NAMES.length) + MASCOT_NAMES.length) % MASCOT_NAMES.length
    : (mascotIndex(value) ?? 0);
  return MASCOT_NAMES[idx];
}

function Mascot({ id = 0, size = 56, style, className }) {
  const name = mascotName(id);
  return (
    <img
      src={`/avatars/${name}.svg`}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      style={{ display: 'block', width: size, height: size, objectFit: 'contain', ...style }}
      className={className}
    />
  );
}

export default Mascot;
